import { render } from "./IconBase.vue?vue&type=template&id=4e9fb000"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e9fb000"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e9fb000', __exports__)) {
    api.reload('4e9fb000', __exports__)
  }
  
  module.hot.accept("./IconBase.vue?vue&type=template&id=4e9fb000", () => {
    api.rerender('4e9fb000', render)
  })

}


export default __exports__